import React, { useEffect } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const RebalanceResultModal = ({ 
  open, 
  onClose, 
  status = { success: [], failed: [] }
}) => {
  const { success = [], failed = [] } = status || {};
  const isSuccess = success.length > 0;
  

  if (!open) return null;

  return (
    <Modal 
      open={open} 
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box sx={{
        bgcolor: 'background.paper',
        borderRadius: '8px',
        boxShadow: 24,
        p: 4,
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center'
      }}>
        {isSuccess ? (
          <>
            <CheckCircleOutlineIcon 
              sx={{ 
                fontSize: 64, 
                color: '#2E7D32',
                mb: 2 
              }} 
            />
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
              Rebalance Successful
            </Typography>
            <Typography sx={{ mb: 3, color: '#666666' }}>
              The rebalance operation has been completed successfully.
            </Typography>
          </>
        ) : (
          <>
            <ErrorOutlineIcon 
              sx={{ 
                fontSize: 64, 
                color: '#D32F2F',
                mb: 2 
              }} 
            />
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
              Rebalance Failed
            </Typography>
            <Typography sx={{ mb: 3, color: '#666666' }}>
              {failed[0]?.message || 'An error occurred during rebalancing.'}
            </Typography>
          </>
        )}

        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            textTransform: 'none',
            minWidth: '120px',
            bgcolor: isSuccess ? '#2E7D32' : '#D32F2F',
            '&:hover': {
              bgcolor: isSuccess ? '#1B5E20' : '#C62828'
            }
          }}
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default RebalanceResultModal; 